//* eslint-disable @typescript-eslint/no-explicit-any */
//* eslint-disable react/display-name */
import {
  ContentState,
  EditorState,
  convertFromHTML,
  convertToRaw,
} from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import React, { forwardRef, useEffect, useState } from 'react'
import { Editor } from 'react-draft-wysiwyg'

import { ENTER_MSG } from '../constants/rhybus-config'
import InputLabel from './input-label'
import './richtext.css'

const MAX_CHAR_LIMIT = 800// Default Amount, can set character limit from parent using maxCharLimit prop

const RichTextEditor = forwardRef((inputProps: any, ref: any) => {
  const { editorValue, maxCharLimit = MAX_CHAR_LIMIT } = inputProps
  const [contentState, setContentState] = useState(EditorState.createEmpty())
  const [charCount, setCharCount] = useState(0)

  const onSetEditorState = (newState: EditorState) => {
    // Convert the current editor state to HTML (including tags)
    const editorContent = draftToHtml(convertToRaw(newState.getCurrentContent()))
    const htmlLength = editorContent.length


    // If the length is within the allowed limit, update the state
    if (htmlLength <= maxCharLimit) {
      setContentState(newState)
    }
    htmlLength === 8 ? setCharCount(0) : setCharCount(htmlLength)
  }

  const handleBeforeInput = (input: string) => {
    const editorContent = draftToHtml(convertToRaw(contentState.getCurrentContent()))
    const htmlLength = editorContent.length

    // Prevent additional input if the max character limit is reached
    if (htmlLength >= maxCharLimit && input !== 'Backspace') {
      return 'handled'
    }

    return 'not-handled'
  }

  useEffect(() => {
    if (typeof editorValue === 'string') {
      const blocksFromHTML = convertFromHTML(editorValue)
      const contentStateFromHTML =
       ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap)
      setContentState(EditorState.createWithContent(contentStateFromHTML))
    }
  }, [editorValue])

  useEffect(() => {
    sendDataToParent()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentState])
  const sendDataToParent = () => {
        if (!inputProps.readOnly) {
          inputProps?.sendValue(contentState)
        }
      }
      
  return (
    <>
      <div className={inputProps?.formClassName}>
        {inputProps?.label && (
          <InputLabel
            className={inputProps?.inputProps?.className}
            infoLabel={inputProps?.info}
            isinfoClassName={inputProps?.infoClassName}
            isinfoIcon={inputProps?.infoIcon}
            isinfoLabel={inputProps?.isInfo}
            label={inputProps?.label}
            labelProps={{ htmlFor: inputProps?.inputProps?.id }}
            mandatory={inputProps?.isMandatory}
          />
        )}

        <Editor
          ariaLabel={inputProps?.label}
          editorState={contentState}
          handleBeforeInput={handleBeforeInput} // Prevent extra input when limit is reached
          onEditorStateChange={onSetEditorState}
          placeholder={inputProps?.placeholder || `Enter ${inputProps?.label}`}
          ref={ref}
          toolbar={{
            history: { inDropdown: true },
            inline: { inDropdown: true },
            link: { inDropdown: true },
            list: { inDropdown: true },
            options: ['blockType', 'inline', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'image', 'remove'],
            textAlign: { inDropdown: true },
          }}
        />

        {/* Display character count and warning if limit exceeded */}
        <div>
          {/* {charCount }/{maxCharLimit} characters */}
          {charCount >= maxCharLimit && (
            <span style={{ color: 'red' }}>Maximum character limit reached</span>
          )}
        </div>
      </div>
      {inputProps?.hint && <div>{inputProps?.hint}</div>}
      {inputProps.error ? (
        <p className='errormsg'>
          {ENTER_MSG} {inputProps?.label || inputProps['aria-label']}
        </p>
      ) : (
        ''
      )}
    </>
  )
})

RichTextEditor.displayName = 'RichTextEditor'
export default RichTextEditor
